import React, { DetailedHTMLProps, InputHTMLAttributes } from "react";

import classnames from "classnames";

type CardProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

const Card: React.FC<CardProps> = ({ children, className, ...props }) => {
  const cardStyle = classnames(
    "overflow-hidden bg-white shadow sm:rounded",
    className
  );

  return (
    <div className={cardStyle} {...props}>
      {children}
    </div>
  );
};

export default React.memo(Card);
